import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
    useEffect,
} from 'react'

import DataElement from '../../../../../../Components/DataElement'

import StatusIcon from '../../../../../../Components/Common/StatusIcon'

const AdditionalInformation = forwardRef(({ title, attributes, data, isSelected, handleFieldSelection }, ref) => {

    const dataElementRef = useRef()
    const [isOpen, setIsOpen] = useState(isSelected)

    const [completed, setCompleted] = useState(false)

    useEffect(() => {
        setIsOpen(isSelected)
    }, [isSelected])

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const additionalInformationResult = dataElementRef.current.validateAndGetData()

            const isValid = additionalInformationResult.isValid

            setCompleted(isValid)

            return additionalInformationResult
        },
    }))

    const handleOpen = () => {
        if (isOpen) {
            setCompleted(dataElementRef.current.validateAndGetData().isValid)
        }
        if (isSelected) {
            setIsOpen(!isOpen)
            return
        }
        handleFieldSelection()
    }

    return (
        <div className="mb-4">

            <button
                onClick={handleOpen}
                className="w-full flex justify-between items-center py-2 px-0"
            >
                <span className="text-lg font-semibold">{title}</span>
                <span className={`pr-4 flex items-center gap-1`}> <StatusIcon isOpen={isOpen} completed={completed} /> {isOpen ? '▲' : '▼'}</span>
            </button>
            <div className={`${!isOpen ? 'hidden' : ''} pt-2`}>
                <DataElement
                    ref={dataElementRef}
                    attributes={attributes}
                    data={data}
                />
            </div>
        </div>
    )
})

export default AdditionalInformation
